import Image from "next/image";
import { useState } from "react";
import { FALLBACK_STORY_IMAGE } from "../../lib/homepage/news";

interface NewsImageProps {
  src: string | null | undefined;
  alt?: string;
  className?: string;
  sizes?: string;
  priority?: boolean;
}

const NewsImage = ({
  src,
  alt = "",
  className = "object-cover",
  sizes,
  priority = false,
}: NewsImageProps) => {
  // Next.js can keep this component mounted while changing article routes.
  // Derive the requested image from the current prop instead of keeping the
  // first article's src in state. Only remember a failed URL for fallback.
  const requestedSrc = src || FALLBACK_STORY_IMAGE;
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const currentSrc = requestedSrc === failedSrc ? FALLBACK_STORY_IMAGE : requestedSrc;

  return (
    <Image
      key={currentSrc}
      src={currentSrc}
      alt={alt}
      fill
      sizes={sizes}
      priority={priority}
      className={className}
      unoptimized={currentSrc.startsWith("https://") || currentSrc.startsWith("http://")}
      onError={() => {
        if (currentSrc !== FALLBACK_STORY_IMAGE) {
          setFailedSrc(requestedSrc);
        }
      }}
    />
  );
};

export default NewsImage;
